// extracted by mini-css-extract-plugin
module.exports = {"strategyTable":"antd-pro-components-table-with-pagination-pagination.styles-strategyTable"};